import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/styles';
import { AppBar, Badge, Hidden, IconButton, MenuItem, Toolbar, useMediaQuery } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import InputIcon from '@material-ui/icons/Input';
import Menu from '@material-ui/core/Menu';
import { withStyles } from '@material-ui/core/styles';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import PersonIcon from '@material-ui/icons/Person';
import { Values } from '../../../../values/Values';
import { FaUserCheck } from 'react-icons/fa';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import moment from 'moment';
import List from '@material-ui/core/List';
import SettingsIcon from '@material-ui/icons/Settings';
import PageviewIcon from '@material-ui/icons/Pageview';
import FindInPageIcon from '@material-ui/icons/FindInPage';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})(props => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles(theme => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);



const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    backgroundColor: Values.cores.cinza
  },
  flexGrow: {
    flexGrow: 1
  },
  signOutButton: {
  },
  backgroundCinza: {
    backgroundColor: Values.cores.cinza
  },
  backgroundCorPrimaria: {
    backgroundColor: Values.cores.corPrimaria
  }
}));

const Topbar = props => {
  const { className, onSidebarOpen, history, usuariosConectados, logout, ...rest } = props;
  const [openMenu, setOpenMenu] = React.useState(null);
  const [openDialogConfirmation, setOpenDialogConfirmation] = useState(false);
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function logoutConfirmado(event) {
    event.preventDefault();
    logout();
  }

  function logoutConfirmation(e) {
    setOpenMenu(null);
    setOpenDialogConfirmation(true);
  }

  function closeLogoutConfirmation(e){
    setOpenDialogConfirmation(false);
  }

  const clickOpenMenu = event => {
    setOpenMenu(event.currentTarget);
  };

  const clickCloseMenu = () => {
    setOpenMenu(null);
  };

  function openPerfilUsuarioLogado(e) {
    history.push('/usuario-profile');
    setOpenMenu(null);
  }

  function abrirConfiguracoes(e) {
    history.push('/settings');
    setOpenMenu(null);
  }

  function abrirListagemConexaoUsuario(event) {
    event.preventDefault();
    history.push('/conexao-usuario');
    setOpenMenu(null);
  }

  function abrirListagemLogs(event) {
    event.preventDefault();
    history.push('/log-list');
    setOpenMenu(null);
  }

  return (
    <AppBar
      {...rest}
      position={'fixed'}
      className={clsx({
        [classes.root]: true,
        [className]: true,
        [classes.backgroundCinza]: isDesktop,
        [classes.backgroundCorPrimaria]: !isDesktop,

      })}

    >
      <Dialog
        open={openDialogConfirmation}
        onClose={e => closeLogoutConfirmation(e)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmação"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Tem certeza que deseja realizar sair?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={e => closeLogoutConfirmation(e)} color="primary">
            Cancelar
          </Button>
          <Button onClick={e => logoutConfirmado(e)} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <Toolbar>
        <Hidden xsDown smDown>
          <img
            height={'45px'}
            width={'200px'}
            alt="Logo"
            src={isDesktop ? "/images/logos/logoCTGverde.png" : "/images/logos/logotiro3.png"}
            style={{
              marginTop: 10,
              marginBottom: 10
            }}
          />
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color={isDesktop ? Values.cores.corPrimaria : 'inherit'}
            onClick={onSidebarOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
        <div className={classes.flexGrow} />
        <Hidden>
          <IconButton
            onClick={handleClick}
            color={isDesktop ? Values.cores.corPrimaria : 'inherit'}
          >
            <Badge
              badgeContent={usuariosConectados.length}
              color="error"
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <FaUserCheck  size={'24px'} />
            </Badge>

          </IconButton>
        </Hidden>
        <Hidden>
          <IconButton
            onClick={clickOpenMenu}
            color={isDesktop ? Values.cores.corPrimaria : 'inherit'}
          >
            <MoreVertIcon />
          </IconButton>
        </Hidden>
        <StyledMenu
          id="customized-menu"
          anchorEl={openMenu}
          keepMounted
          open={Boolean(openMenu)}
          onClose={clickCloseMenu}
        >
          <StyledMenuItem
            onClick={e => openPerfilUsuarioLogado(e)}
          >
            <ListItemIcon>
              <PersonIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Perfil" />
          </StyledMenuItem>
          <StyledMenuItem
            onClick={e => abrirConfiguracoes(e)}
          >
            <ListItemIcon>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Configurações" />
          </StyledMenuItem>
          <StyledMenuItem
            onClick={e => abrirListagemLogs(e)}
          >
            <ListItemIcon>
              <FindInPageIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="LOGS" />
          </StyledMenuItem>
          <StyledMenuItem
            onClick={e => logoutConfirmation(e)}
          >
            <ListItemIcon
            >
              <InputIcon/>
            </ListItemIcon>
            <ListItemText primary="Sair" />
          </StyledMenuItem>
        </StyledMenu>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          getContentAnchorEl={null}
        >
          {
            usuariosConectados.map((conexao, index) => {
              return (
                <MenuItem onClick={handleClose} key={index}>
                  <List>
                    <ListItem alignItems="flex-start">
                      <ListItemAvatar>
                        <StyledBadge
                          overlap="circle"
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                          }}
                          variant="dot"
                        >
                          <Avatar alt="Usuário conectado" ><FaUserCheck/></Avatar>
                        </StyledBadge>
                      </ListItemAvatar>
                      <ListItemText
                        primary={conexao.usuario.nomeFantasia}
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="body2"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {conexao.usuario.tipoUsuario.descricao}
                            </Typography>
                            {` - ultima atividade às ${moment(conexao.updatedAt).format('HH:mm')}`}
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                  </List>
                </MenuItem>
              );
            })
          }
          <MenuItem
            key={'verMaisUsuarios'}
            onClick={e => abrirListagemConexaoUsuario(e)}
          >
            <Button
              variant="text"
              color={'primary'}
              fullWidth
              startIcon={<PageviewIcon />}
              disabled
              style={{
                color: Values.cores.corPrimaria
              }}
            >
              Ver mais
            </Button>

          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func
};

export default Topbar;
